import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { canViewPartLibrarySourcing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// Where IPN links go. No tab of its own: it opens the first the user may open, and each tab checks its own access.
export const Route = createFileRoute('/_authenticated/next/components/ipn/_details/')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ ipnId: 'required' }),
    beforeLoad: ({ context, search }) => {
        throw redirect({
            to: canViewPartLibrarySourcing(context.session)
                ? '/parts/components/ipn/offers'
                : '/parts/components/ipn/used-in',
            search: { ipnId: search.ipnId },
            replace: true,
        });
    },
});
